import {
  BasicAccountApplicationDocument,
  CardApplicationDocument,
  SigningProcessDocument,
} from "../../../../api/commercial/generated-types";

export interface ApplicationFlowPropType {
  activeChapter: ApplicationChapterId;
  step: ApplicationFlowSteps;
  setStep: (step: ApplicationFlowSteps) => void;
  basicAccountApplication: BasicAccountApplicationDocument;
  cardApplication: CardApplicationDocument;
  signingProcess?: SigningProcessDocument;
  triggerReload: () => void;
}

export enum ApplicationChapterId {
  Company = "COMPANY",
  Account = "ACCOUNT",
  RegulatoryInformation = "REGULATORY_INFORMATION",
  PowerOfAttorney = "POWER_OF_ATTORNEY",
  CompanyOnline = "CompanyOnline",
  Cardholder = "CARDHOLDER",
  SignatoriesAndAppFinalization = "SIGNATORIES_AND_APP_FINALIZATION",
  UploadAttachments = "UPLOAD_ATTACHMENTS",
  Dashboard = "DASHBOARD",
}

export enum ApplicationFlows {
  ANONYMOUS = "ANONYMOUS",
  FIRST_BAA = "FIRST_BAA",
  ADDITIONAL_BAA = "ADDITIONAL_BAA",
  ADDITIONAL_CA = "ADDITIONAL_CA",
  NO_APPLICATIONS_FLOW = "NO_APPLICATIONS",
}

export enum ApplicationFlowSteps {
  BASIC_ACCOUNT_INFORMATION = "BASIC_ACCOUNT_INFORMATION",
  BASIC_ACCOUNT_BENEFITS = "BASIC_ACCOUNT_BENEFITS",
  REGULATORY_INFORMATION = "REGULATORY_INFORMATION",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  COMPANY_ONLINE = "COMPANY_ONLINE",
  CARDHOLDER = "CARDHOLDER",
  CARDHOLDER_BENEFITS = "CARDHOLDER_BENEFITS",
  CHOOSE_SIGNATORIES = "CHOOSE_SIGNATORIES",
  SUMMARY = "SUMMARY",
  SIGN = "SIGN",
  UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS",
  DASHBOARD = "DASHBOARD",
  COMPANY = "COMPANY",
  REGISTRATION = "REGISTRATION",
  EMAIL_OTP = "EMAIL_OTP",
}

export const stepToChapter: {
  [key in ApplicationFlowSteps]?: ApplicationChapterId;
} = {
  [ApplicationFlowSteps.COMPANY]: ApplicationChapterId.Company,
  [ApplicationFlowSteps.REGISTRATION]: ApplicationChapterId.Company,
  [ApplicationFlowSteps.BASIC_ACCOUNT_INFORMATION]:
    ApplicationChapterId.Account,
  [ApplicationFlowSteps.BASIC_ACCOUNT_BENEFITS]: ApplicationChapterId.Account,
  [ApplicationFlowSteps.REGULATORY_INFORMATION]:
    ApplicationChapterId.RegulatoryInformation,
  [ApplicationFlowSteps.POWER_OF_ATTORNEY]:
    ApplicationChapterId.PowerOfAttorney,
  [ApplicationFlowSteps.COMPANY_ONLINE]: ApplicationChapterId.CompanyOnline,
  [ApplicationFlowSteps.CARDHOLDER]: ApplicationChapterId.Cardholder,
  [ApplicationFlowSteps.CARDHOLDER_BENEFITS]: ApplicationChapterId.Cardholder,
  [ApplicationFlowSteps.CHOOSE_SIGNATORIES]:
    ApplicationChapterId.SignatoriesAndAppFinalization,
  [ApplicationFlowSteps.SUMMARY]:
    ApplicationChapterId.SignatoriesAndAppFinalization,
  [ApplicationFlowSteps.SIGN]:
    ApplicationChapterId.SignatoriesAndAppFinalization,
  [ApplicationFlowSteps.UPLOAD_ATTACHMENTS]:
    ApplicationChapterId.UploadAttachments,
};

export enum FlowPosition {
  IN_BAA,
  IN_CA,
}

export const stepToFlowPosition: {
  [key in ApplicationFlowSteps]?: FlowPosition;
} = {
  [ApplicationFlowSteps.COMPANY]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.REGISTRATION]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.BASIC_ACCOUNT_INFORMATION]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.BASIC_ACCOUNT_BENEFITS]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.REGULATORY_INFORMATION]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.POWER_OF_ATTORNEY]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.CARDHOLDER]: FlowPosition.IN_BAA,
  [ApplicationFlowSteps.CARDHOLDER_BENEFITS]: FlowPosition.IN_CA,
  [ApplicationFlowSteps.CHOOSE_SIGNATORIES]: FlowPosition.IN_CA,
  [ApplicationFlowSteps.SUMMARY]: FlowPosition.IN_CA,
  [ApplicationFlowSteps.SIGN]: FlowPosition.IN_CA,
  [ApplicationFlowSteps.UPLOAD_ATTACHMENTS]: FlowPosition.IN_BAA,
};
